<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.lytk1">
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Carbon Block</span>
          </u>
        </b>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.lytk2">
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Anode</span>
          </u>
        </b>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.lytk3">
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Electrode Paste</span>
          </u>
        </b>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.lytk4">
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Graphite Block</span>
          </u>
        </b>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.lytk5">
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Calcined Coke</span>
          </u>
        </b>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.lytk6">
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Calcined Coal</span>
          </u>
        </b>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lytk1: require("../../../assets/img/common/lytk1.jpg"),
        lytk2: require("../../../assets/img/common/lytk2.jpg"),
        lytk3: require("../../../assets/img/common/lytk3.jpg"),
        lytk4: require("../../../assets/img/common/lytk4.jpg"),
        lytk5: require("../../../assets/img/common/lytk5.jpg"),
        lytk6: require("../../../assets/img/common/lytk6.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/product/lytk.vue